module.exports = __webpack_public_path__ + "img/u1.7413383a.png";